import React from 'react';
import { Field, FieldArray, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import Modal from '../../../SharedComponents/Modal';
import PlusCircle from '../../../SharedComponents/Svg/PlusCircle';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Loading from '../../../SharedComponents/Loading';
import { useTranslation } from 'react-i18next';
import LanguageList from '../../../SharedComponents/LanguageList';
import { ChangeRequestStatus, getLanguages } from '../../Requests/ApRequests';
import { useHistory, useParams } from 'react-router';
import { dir } from '../../../utils/localisation';
import axios from 'axios';
// import { sendMessage } from '../../utils/sendMessage';

export default function AcceptSubmission(props) {
  const [isOpen, setIsOpen] = useState(false);
  const { id } = props.id ? props : 1;
  const { typeId, submitionUserId } = props;
  const { t, i18n } = useTranslation();
  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`bg-green-500 space-x-1 ${
          i18n.language === 'en' ? '' : 'space-x-reverse'
        } text-sm font-bold text-white flex items-center hover:bg-green-600 shadow  px-4 py-2 rounded transition duration-300 ease-in-out`}
      >
        {' '}
        <span>موافقة على الطلب</span>
      </button>

      {isOpen && (
        <ModalContainer
          submitionUserId={submitionUserId}
          id={id}
          typeId={typeId}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
}

const ModalContainer = (props) => {
  const { isOpen, setIsOpen, submitionUserId } = props;
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const userData = localStorage.getItem('token');
  const userId = JSON.parse(userData).userId;

  const initialValues = {
    id: parseInt(id),
    reply: 'تمت الموافقة',
    submitionStatus: 1,
    submitionReply: {
      submittionId: parseInt(id),
      reply: 'تمت الموافقة',
    },
  };
  const history = useHistory();
  const queryClient = useQueryClient();

  const addNotificationMutation = useMutation(addNotification, {
    onSuccess: async (data) => {
      queryClient.invalidateQueries(['getSubmittionsById']);
      queryClient.invalidateQueries(['GetByRepliesForSubmittion']);
      setIsOpen(false);
    },
  });
  // Mutate Data to Create New Page
  const mutation = useMutation(ChangeSubmittionStatus, {
    onSuccess: async (data, variables) => {
      if (data.isDone) {
        console.log('variables', variables);
        addNotificationMutation.mutate({
          userId: submitionUserId,
          message: variables.submitionReply.reply,
          notificationStatus: 1,
        });
      }
    },
  });

  const onSubmit = (e) => {
    try {
      mutation.mutate(e);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <>
      <Formik onSubmit={onSubmit} validateOnBlur={false} validateOnChange={false} initialValues={initialValues}>
        {({ values, setFieldValue, errors }) => {
          return (
            <Form>
              <Modal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                // onSubmit={onSubmit}
                title={`موافقة على الطلب`}
                isLoading={mutation.isLoading}
                add={true}
              >
                {/* Submit Form */}

                <label className={`flex  flex-col ${dir('justify-start', 'justify-end')}  space-y-2`}>
                  <span className={`font-bold text-base ${dir('text-right', 'text-right')}`}>رسالة العميل</span>
                  <Field name="submitionReply.reply" className="border rounded py-2 px-3" as="textarea" />
                </label>
              </Modal>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export const ChangeSubmittionStatus = async (e) => {
  console.log('e', e);
  const { data } = await axios.post(`/Submittion/ChangeSubmittionStatus`, e);
  return data;
};

export const addNotification = async (e) => {
  console.log('e', e);
  const { data } = await axios.post(`/Notifications/Add`, e);
  return data;
};
